
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.939 10.364a.914.914 0 110 1.828.914.914 0 010-1.828zm.04-6.17l.167.004c.553.04.983.222 1.355.672.437.529.575 1.232.323 1.885-.125.325-.29.543-.546.786-.331.312-.312.293-.41.443-.1.152-.111.2-.108.348l.001.03v.096a.8.8 0 11-1.6-.045V8.37c-.01-.447.068-.806.368-1.264a3.07 3.07 0 01.37-.462c.055-.055.23-.22.294-.28l.05-.05a.364.364 0 00.088-.135c.037-.094.017-.192-.063-.29-.062-.075-.084-.084-.234-.095-.176-.012-.431.11-.548.262a.8.8 0 11-1.27-.972c.436-.572 1.206-.936 1.93-.886z","fill":"#FFF"}})])])
          )
        }
      }
    